import { InjectionToken } from '@angular/core';

export interface ConsentConfig {
  version: string;
  tos: string;
  gtc: string;
}

export const CONSENT_CONFIG = new InjectionToken<ConsentConfig>('CONSENT_CONFIG');
